import styled from 'styled-components'
import PropTypes from 'prop-types'

const sizes = {
  label: { width: '30%' },
  input: { height: 'var(--font-size-5)', radius: 'var(--border-radius-0-5)' },
  title: { width: '40%', height: 'var(--font-size-3)' },
  button: { width: '40%', height: 'var(--font-size-6)', radius: 'var(--border-radius-3)' },
  default: { width: '100%', height: 'var(--font-size-2-5)' },
}
const units = ['px', '%', 'rem', 'em', 'var']

const handleUnit = value => {
  if (!value) return '100%'
  if (units.find(x => value.indexOf(x) > -1)) return value
  return `${value}px`
}

const handleSize = (prop, props) => {
  let value = sizes.default[prop]
  if (props.type === 'custom') {
    if (props[prop]) {
      value = handleUnit(props[prop])
    }
  } else if (sizes[props.type][prop]) {
    value = sizes[props.type][prop]
  }
  return value
}

export const Skeleton = styled.div`
  display: flex;
  background-color: var(--color-neutral-90);
  width: ${props => handleSize('width', props)};
  height: ${props => handleSize('height', props)};
  border-radius: ${props => handleSize('radius', props)};
`

Skeleton.propTypes = {
  type: PropTypes.oneOf(['custom', 'label', 'input', 'title', 'button']),
}

Skeleton.defaultProps = {
  type: 'custom',
}
